import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
    breakpoints: {
      xs: "320px",
      s: '400px',
      sm: "480px",
      md: "768px",
      lg: "1024px",
      xl: "1440px",
      desktop: "1920px",
      xxl: "2560px",
    },
  });
  